module.exports = __webpack_public_path__ + "static/media/eject.0cb86791.svg";